var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.1,16.7c-0.4,0.1-0.6,0.4-0.6,0.8c0,0.8,0.7,1.5,1.5,1.5c0.6,0,1.1,0.4,1.2,1c-0.8,0.1-1.4,0.6-1.7,1.4 h-1C15.7,21.5,15,22.2,15,23v14.5h15V23c0-0.8-0.7-1.5-1.5-1.6h-1c-0.3-0.8-0.9-1.3-1.7-1.4c0.1-0.6,0.6-1,1.2-1 c0.8,0,1.5-0.7,1.5-1.5c0-0.4-0.2-0.7-0.6-0.9v-2.3c0.4-0.2,0.6-0.6,0.6-1c0-0.5-0.2-0.9-0.6-1.1V9.9c0.4-0.2,0.6-0.5,0.6-0.9 c0-0.8-0.7-1.5-1.5-1.5h-9c-0.8,0-1.5,0.7-1.5,1.5c0,0.4,0.2,0.7,0.6,0.9v2.3c-0.4,0.2-0.6,0.6-0.6,1.1c0,0.4,0.2,0.8,0.6,1V16.7z  M17.1,36.9v-1.2h10.8v1.2H17.1z M17.1,26.6c0-0.8,0.7-1.5,1.5-1.5h7.8c0.8,0,1.5,0.7,1.5,1.5v8.5H17.1V26.6z M29.4,36.9h-0.9V26.6 c0-1.2-0.9-2.1-2.1-2.1h-7.8c-1.2,0-2.1,0.9-2.1,2.1v10.3h-0.9V23c0-0.5,0.4-0.9,0.9-1h12c0.5,0.1,0.9,0.5,0.9,1V36.9z M26.9,21.4 h-8.8c0.3-0.5,0.8-0.9,1.4-0.9h6C26.1,20.5,26.6,20.9,26.9,21.4z M27,18.4h-6V19h4.7c-0.2,0.3-0.4,0.6-0.5,0.9h-5.4 c-0.1-0.3-0.3-0.6-0.5-0.9h1.1v-0.6H18c-0.5,0-0.9-0.4-0.9-0.9c0-0.2,0.1-0.3,0.3-0.3h10.2c0.2,0,0.3,0.1,0.3,0.3 C27.9,18,27.5,18.4,27,18.4z M27.3,16.6h-9.6v-2.1h9.6V16.6z M18,8.1h9c0.5,0,0.9,0.4,0.9,0.9c0,0.2-0.1,0.3-0.3,0.3H17.4 c-0.2,0-0.3-0.1-0.3-0.3C17.1,8.5,17.5,8.1,18,8.1z M17.5,12.7h6.8V12h-6.6V9.9h9.6V12h-2.4v0.7h2.6c0.2,0.1,0.4,0.3,0.4,0.6 c0,0.2-0.2,0.4-0.4,0.5h-10c-0.2-0.1-0.4-0.3-0.4-0.5C17.1,13,17.3,12.8,17.5,12.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1,
    y: 35.7,
    fill: "#FFFFFF",
    width: 10.8,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M17.1,35.1h10.8v-8.5c0-0.8-0.7-1.5-1.5-1.5h-7.8c-0.8,0-1.5,0.7-1.5,1.5V35.1z M25.4,29.6 c0,0.5-0.4,0.9-0.9,0.9v1.2h-0.6v-1.2c-0.5-0.1-0.8-0.4-0.8-0.9V28c0-0.5,0.3-0.8,0.8-0.9h0.6c0.5,0,0.9,0.4,0.9,0.9V29.6z  M20.5,27.1h0.6c0.5,0.1,0.8,0.4,0.8,0.9v1.6c0,0.5-0.3,0.8-0.8,0.9v1.2h-0.6v-1.2c-0.5,0-0.9-0.4-0.9-0.9V28 C19.6,27.5,20,27.1,20.5,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M19.5,20.5c-0.6,0-1.1,0.4-1.4,0.9h8.8c-0.3-0.5-0.8-0.9-1.4-0.9H19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.4,23c0-0.5-0.4-0.9-0.9-1h-12c-0.5,0.1-0.9,0.5-0.9,1v13.9h0.9V26.6c0-1.2,0.9-2.1,2.1-2.1h7.8 c1.2,0,2.1,0.9,2.1,2.1v10.3h0.9V23z M23.1,23.7H22h-0.1h-1.1v-1.2h1.1H22h1.1h1.2v1.2H23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M17.4,9.3h10.2c0.2,0,0.3-0.1,0.3-0.3c0-0.5-0.4-0.9-0.9-0.9h-9c-0.5,0-0.9,0.4-0.9,0.9 C17.1,9.2,17.2,9.3,17.4,9.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 14.5,
    fill: "#4AB8DC",
    width: 9.6,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M17.5,13.8h10c0.2-0.1,0.4-0.3,0.4-0.5c0-0.3-0.2-0.5-0.4-0.6h-2.6V12h2.4V9.9h-9.6V12h6.6v0.7h-6.8 c-0.2,0.1-0.4,0.3-0.4,0.6C17.1,13.5,17.3,13.7,17.5,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M27.6,17.2H17.4c-0.2,0-0.3,0.1-0.3,0.3c0,0.5,0.4,0.9,0.9,0.9h2.4V19h-1.1c0.2,0.3,0.4,0.6,0.5,0.9h5.4 c0.1-0.3,0.3-0.6,0.5-0.9H21v-0.6h6c0.5,0,0.9-0.4,0.9-0.9C27.9,17.3,27.8,17.2,27.6,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.6,29.6c0,0.5,0.4,0.9,0.9,0.9v1.2h0.6v-1.2c0.5-0.1,0.8-0.4,0.8-0.9V28c0-0.5-0.3-0.8-0.8-0.9h-0.6 c-0.5,0-0.9,0.4-0.9,0.9V29.6z M21.3,29.6c0,0.1-0.1,0.3-0.2,0.3h-0.6c-0.2,0-0.3-0.1-0.3-0.3v-0.9h1.1V29.6z M20.5,27.7h0.6 c0.1,0,0.2,0.2,0.2,0.3h-1.1C20.2,27.8,20.3,27.7,20.5,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M21.1,27.7h-0.6c-0.2,0-0.3,0.1-0.3,0.3h1.1C21.3,27.9,21.2,27.7,21.1,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M20.2,29.6c0,0.2,0.1,0.3,0.3,0.3h0.6c0.1,0,0.2-0.2,0.2-0.3v-0.9h-1.1V29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M24.5,27.1h-0.6c-0.5,0.1-0.8,0.4-0.8,0.9v1.6c0,0.5,0.3,0.8,0.8,0.9v1.2h0.6v-1.2c0.5,0,0.9-0.4,0.9-0.9 V28C25.4,27.5,25,27.1,24.5,27.1z M24.8,29.6c0,0.2-0.1,0.3-0.3,0.3h-0.6c-0.1,0-0.2-0.2-0.2-0.3v-0.9h1.1V29.6z M23.9,27.7h0.6 c0.2,0,0.3,0.1,0.3,0.3h-1.1C23.7,27.9,23.8,27.7,23.9,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M24.5,27.7h-0.6c-0.1,0-0.2,0.2-0.2,0.3h1.1C24.8,27.8,24.7,27.7,24.5,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M23.7,29.6c0,0.1,0.1,0.3,0.2,0.3h0.6c0.2,0,0.3-0.1,0.3-0.3v-0.9h-1.1V29.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 22.5,
    fill: "#28B557",
    width: 1.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4AB8DC",
    points: "23.1,22.5 22,22.5 21.9,22.5 21.9,23.7 22,23.7 23.1,23.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1,
    y: 22.5,
    fill: "#F2724A",
    width: 1.2,
    height: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.ddb6df2d23fa61b0942867025880db1f.svg";
export { ForwardRef as ReactComponent };